import { render } from "./KonfirmLogoutPerusahaan.vue?vue&type=template&id=0e55e789&scoped=true"
import script from "./KonfirmLogoutPerusahaan.vue?vue&type=script&lang=js"
export * from "./KonfirmLogoutPerusahaan.vue?vue&type=script&lang=js"

import "./KonfirmLogoutPerusahaan.vue?vue&type=style&index=0&id=0e55e789&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e55e789"

export default script